// extracted by mini-css-extract-plugin
module.exports = {"ContentFlex":"ContentFlex-module__ContentFlex___3Z7xF"};